/* eslint-disable no-unused-vars */

import { message, Menu } from 'antd';
import { useDispatch, useSelector } from 'dva';
import styles from './index.less?modules';
import classnames from 'classnames';
import { useState, useEffect, useCallback } from 'react';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
// import ButtonML from '@/components/button_ml/ButtonML';
import ModalML from '@/components/modal_ml/ModalML';
import AddMember from './add/components/add_member/AddMember';
import EditMember from './add/components/edit_member/EditMember';
import OperateLog from './components/operate_log/OperateLog';
import { history } from 'umi';
import dayjs from 'dayjs';

const MemberManagement = (props) => {
  const dispatch = useDispatch();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['ruleginDGM/getGraphTable'];
  const [params, setParams] = useState({});
  const [modalVisible, setVisible] = useState(false);
  const [modalVisible2, setVisible2] = useState(false);
  const [modalVisible3, setVisible3] = useState(false);
  const [logTableData, setLogTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [name, setName] = useState('');
  const [versionIndex, setVersionIndex] = useState(0);
  const [menuList, setMenuList] = useState([]);
  const [itemInfo, setItemInfo] = useState({});

  const handleSearch = (par) => {
    if (par.createTimeBegin) {
      par.createTimeBegin = dayjs(par.createTimeBegin.$d).format(
        'YYYY-MM-DD HH:mm:ss',
      );
    }
    if (par.createTimeEnd) {
      par.createTimeEnd = dayjs(par.createTimeEnd.$d).format(
        'YYYY-MM-DD HH:mm:ss',
      );
    }
    par.diagramName = par.diagramName ? par.diagramName : '';
    setParams({ ...par });
  };

  //选择多个table
  const onSelect = () => {
    // setIdArr(val);
  };
  // 获取决策图列表
  const fetchData = useCallback(() => {
    dispatch({
      type: 'ruleginDGM/getGraphTable',
      payload: {
        values: {
          ...params,
        },
      },
      callback: (res) => {
        if (!res.message) {
          setTableData(res);
        }
      },
    });
  }, [dispatch, params]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const add = (e) => {
    setVisible(true);
  };
  const edit = (e) => {
    setItemInfo(e);
    setVisible2(true);
  };
  const reset = () => {
    dispatch({
      type: 'ruleginDGM/getGraphTable',
      payload: {
        values: {},
      },
    });
  };

  // 新增弹出
  const handleOk = (e) => {
    setVisible(false);
    // setMemberInfo(e.data);
    fetchData();
  };
  // 新增弹入
  const handleCancel = () => {
    setVisible(false);
  };

  // 编辑弹出
  const handleOk2 = (e) => {
    setVisible2(false);
    fetchData();
  };
  // 编辑弹入
  const handleCancel2 = () => {
    setVisible2(false);
  };

  // 编辑弹入
  const handleCancel3 = () => {
    setVisible3(false);
  };

  // 删除
  const deleteGraphItem = (e) => {
    dispatch({
      type: 'ruleginDGM/deleteDiagram',
      payload: {
        modelId: e.id,
        values: { operator: '' },
      },
      callback: (res) => {
        if (res.message) {
          message.error(res.message);
        } else {
          message.success('删除成功');
          fetchData();
        }
      },
    });
  };

  // 打开操作日志弹窗
  const pushLog = (e) => {
    dispatch({
      type: 'ruleginDGM/getDiagramLog',
      payload: {
        values: e.id,
      },
      callback: (res) => {
        setLogTableData(res);
      },
    });
    setVisible3(true);
  };

  const pushDecisionGraphMap = (e) => {
    console.log(e);
    history.push({
      pathname: '/bre/dgm/dgm/dgmp',
      query: {
        id: e.id,
        title: e.name,
        version: e.version,
        saveable: e.editable,
      },
    });
  };

  const handleMenuClick = (e) => {
    dispatch({
      type: 'ruleginDGM/changeVersion',
      payload: {
        values: {
          diagramName: name,
          version: e.key,
        },
      },
      callback: (res) => {
        console.log(res);
        if (res.code !== 0) {
          message.error(res.message);
        } else {
          message.success('版本更改成功');
          let tableDataUnuse = JSON.parse(JSON.stringify(tableData));
          tableDataUnuse[versionIndex] = res.data;
          setTableData(tableDataUnuse);
          // fetchData();
        }
      },
    });
  };
  const getVersion = (e, i) => {
    setName(e.name);
    setVersionIndex(i);
    dispatch({
      type: 'ruleginDGM/getVersion',
      payload: {
        values: {
          diagramName: e.name,
        },
      },
      callback: (res) => {
        if (!res.message) {
          let menuUnuse = [];
          res &&
            res.forEach((item) => {
              menuUnuse.push(<Menu.Item key={item}>{item}</Menu.Item>);
            });
          setMenuList(menuUnuse);
        } else {
          setMenuList([]);
        }
      },
    });
  };

  // let tableData = datas || [];

  let options = [];
  tableData.length > 0 &&
    tableData.forEach((e) => {
      options.push({ name: e.name, value: e.name });
    });

  return (
    <div className={styles.mm_content}>
      <div
        className={classnames(styles.search_group, styles.single_component1)}
      >
        <SearchGroup
          options={options}
          handleSearch={(par) => handleSearch(par)}
          onAdd={add}
          onReset={reset}
        />
      </div>
      <div className={classnames(styles.table_page, styles.single_component)}>
        {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
        <TablePage
          pagination={{
            pageSize: params.limit,
            page: params.page,
          }}
          onSelect={onSelect}
          loading={loading}
          tableData={tableData}
          deleteItem={deleteGraphItem}
          edit={edit}
          pushLog={pushLog}
          pushDecisionGraphMap={pushDecisionGraphMap}
          getVersion={getVersion}
          handleMenuClick={handleMenuClick}
          menuList={menuList}
        />
      </div>
      <ModalML title="新增" visible={modalVisible} handleCancel={handleCancel}>
        <AddMember
          options={options}
          handleOk={handleOk}
          handleCancel={handleCancel}
        />
      </ModalML>
      <ModalML
        title="编辑"
        visible={modalVisible2}
        handleCancel={handleCancel2}
      >
        <EditMember
          itemInfo={itemInfo}
          handleOk={handleOk2}
          handleCancel={handleCancel2}
        />
      </ModalML>
      <ModalML
        title="操作日志"
        width="60vw"
        visible={modalVisible3}
        handleCancel={handleCancel3}
      >
        <OperateLog tableData={logTableData} />
      </ModalML>
    </div>
  );
};

export default MemberManagement;
